import { ColumnProps, TableLowcode } from 'alurkerja-ui'
import { useCustomSpec } from '@/utils/hooks/useCustomSpec'
import { useContext, useEffect, useState } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'

export default function TableTermin() {
  const { watch } = useContext<CustomComponentContextType>(CustomComponentContext)
  const [dataAngsuran, setDataAngsuran] = useState<{
    angsuran_ke: number
    jumlah_angsuran: string
    sisa_nominal: string
  }[]>([])

  useEffect(() => {
    const nominal: number = parseInt(watch('nominal'))
    const termin: number = parseInt(watch('termin'))

    if (!isNaN(nominal) && !isNaN(termin) && termin > 0) {
      const jumlahAngsuranPerTermin = Math.floor(nominal / termin)
      let sisaNominal = nominal

      const hasil: {
        angsuran_ke: number
        jumlah_angsuran: string
        sisa_nominal: string
      }[] = []

      for (let i = 1; i <= termin; i++) {
        sisaNominal -= jumlahAngsuranPerTermin

        hasil.push({
          angsuran_ke: i,
          jumlah_angsuran: jumlahAngsuranPerTermin.toString(),
          sisa_nominal: sisaNominal.toString(),
        })
      }

      setDataAngsuran(hasil)
    } else {
      setDataAngsuran([])
    }
  }, [watch('nominal'), watch('termin')])

  const columns: ColumnProps = [
    { key: 'angsuran_ke', label: 'Angsuran Ke' },
    { key: 'jumlah_angsuran', label: 'Jumlah Angsuran' },
    { key: 'sisa_nominal', label: 'Sisa Nominal' },
  ]

  const customSpec = useCustomSpec('', {
    columns,
    show_detail: true,
  })

  return (
    <>
      <TableLowcode
        data={dataAngsuran}
        spec={customSpec}
        baseUrl={''}
        hideActionColumn={true}
      />
    </>
  )
}